export const DETAIL_TRIGGER_ROLE = 'button';
export const DETAIL_TRIGGER_TAB_INDEX = 0;
export const DETAIL_MODAL_SIZE = 'lg';
export const DETAIL_MODAL_KEYBOARD = false;
export const DETAIL_TRIGGER_LABEL_KEY = 'DEAL_PAYROLL_OPEN_BREAKDOWN';
export const DETAIL_TRIGGER_POPUP = 'dialog';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/deal-payroll-detail/deal-payroll-detail-trigger.constants.ts